import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

export const AddNameNok = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const history = useHistory();
  const contactListId = queryParams.get("contactListId");

  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!contactListId || !name.trim()) {
      return setError("Both fields are required.");
    }

    try {
      const response = await fetch(
        "https://vivesupportnokback-ctfcg7hfgtd6g0h2.canadacentral-01.azurewebsites.net/api/updateContact",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            contactListId,
            NameContact: name,
          }),
        }
      );

      const data = await response.json();

      if (data.win === 1) {
        alert("✅ Name saved successfully!");
        history.push("/loginUser?role=nok"); // 👈 vuelve al login como NOK
      } else {
        setError("❌ Failed to update name.");
      }
    } catch (err) {
      console.error(err);
      setError("❌ Error connecting to server.");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.loginBox}>
        <h2 style={styles.title}>What is your name?</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputContainer}>
            <label style={styles.label}>Full Name:</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={styles.input}
              placeholder="Enter your full name"
              required
            />
          </div>
          {error && <p style={styles.errorMessage}>{error}</p>}
          <button type="submit" style={styles.button}>
            Save
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "linear-gradient(135deg, #0A3A2C, #167D56)",
  },
  loginBox: {
    background: "#fff",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)",
    textAlign: "center",
    width: "350px",
    animation: "fadeIn 0.8s ease-in-out",
  },
  title: {
    marginBottom: "20px",
    fontSize: "22px",
    fontWeight: "bold",
    color: "#0A3A2C",
  },
  form: { display: "flex", flexDirection: "column" },
  inputContainer: { marginBottom: "15px", textAlign: "left" },
  label: { fontSize: "14px", fontWeight: "bold", color: "#333" },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "16px",
  },
  button: {
    padding: "12px",
    backgroundColor: "#0A3A2C",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
  },
  errorMessage: { color: "red", fontSize: "14px", marginTop: "10px" },
};

export default AddNameNok;
